import { Component, OnInit } from '@angular/core';
import { HttpClientAuthServiceService } from '../../httpServices/http-client-auth-service.service'
import { AlertasService } from '../../alerta_servicio/alertas.service'
import { GetPendingPaymentsService } from '../../httpServices/get-pending-payments.service'
import { FormGroup } from '@angular/forms';
import { payments } from './payments.model';

@Component({
  selector: 'app-pague-aqui',
  templateUrl: './pague-aqui.component.html',
  styleUrls: ['./pague-aqui.component.css']
})
export class PagueAquiComponent implements OnInit {

  public selectedItem : any;
  public identificationItem: any;
  public lastId: string;
  public lastTypeId : string;

  public from : FormGroup;

  pendingPayments: any[] = [];

  public nombreDeudor : string;
  public showTable : boolean;

  public radioMinimo : boolean;
  public radioTotal : boolean;
  public selectedOption: string;
  constructor(protected httpService: HttpClientAuthServiceService, private alertas:AlertasService,
    protected getPendingPaymentsService: GetPendingPaymentsService) { }

  ngOnInit(): void {

    this.httpService.login();


  }


 pagar(){
  console.log('z ' + this.selectedOption);


    if(this.selectedOption.startsWith('opcion1') ){
      console.log('minimo');
      console.log(this.radioMinimo);
      console.log(this.radioTotal);
      window.open('https://micrositios.goupagos.com.co/mundo-financiera-sas-mc/login', '_blank');

    }else if(this.selectedOption.startsWith('opcion2') ){
      console.log('maximo');
      console.log(this.radioMinimo);
      console.log(this.radioTotal);
      window.open('https://micrositios.goupagos.com.co/mundo-financiera-sas-ma', '_blank');

    }else{
      this.alertas.showError("Debe Seleccionar Pago Minimo o (parcial) total","Importante");
    }



 }


  getExtracto(pendingPayments_: payments ){

     this.getPendingPaymentsService.getExtractoService_(pendingPayments_.fechaVencimiento+"_"+pendingPayments_.referencia).subscribe((archivo: Blob) => {
      const tipo = archivo.type;
      const nombre = 'EXTRACTO_MUNDOFINANCIERA';

      const url = URL.createObjectURL(archivo);
      const enlace = document.createElement('a');

      enlace.href = url;
      enlace.download = nombre;
      enlace.click();

      URL.revokeObjectURL(url);
    },
    (error) => {
      this.alertas.showError("El extracto aun no ha sido generado","Importante");
    }

    );

  }

  getPendingPayments()
  {

    if(this.selectedItem != null && this.identificationItem != null &&
      (this.selectedItem != this.lastTypeId || this.identificationItem != this.lastId))
    {
      this.getPendingPaymentsService.getPendingPayments_(this.selectedItem,this.identificationItem).subscribe(
        (data) => {
          // Success
          this.pendingPayments = data.body['data']['detalleCobrosActivosDeudorDTO'];

          if(this.pendingPayments.length > 1)
            this.showTable = true;
          else
            this.showTable = true;

          this.nombreDeudor = data.body['data']['nombre'];
          this.lastId = this.identificationItem;
          this.lastTypeId = this.selectedItem;
        },
        (error) => {
          this.lastId = this.identificationItem;
          this.lastTypeId = this.selectedItem;
          this.showTable=false;
          this.alertas.showError(error.error["message"],"Error obteniendo información de pendientes");
        }
      );
    }
  }

}
